module.exports = __webpack_public_path__ + "static/media/drums-double-bass.580ba699.mp3";